// eslint-disable-next-line import/prefer-default-export
export const isEmpty = (obj: Record<string, unknown>) =>
  Object.keys(obj).length === 0;
